import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class Form1118ConfigService {

  constructor(private http: HttpClient) { }

  // 🚀 CRITICAL: Following service pattern exactly
  save(
    baseUrl: string,
    returnObj: any,
    details: any[],
    otherInfo: any,
    globalService: any,
    filterParams: any = {},
    rowData: any = {}
  ): Observable<any> {
    
    // 🚀 CRITICAL: URL construction with action code like AngularJS service
    const url = `${baseUrl}/saveJsonObject?action_code=vb6ugk`;

    // 🚀 CRITICAL: Build clob_settings with required fields
    const clobSettings: any = {
      sso_id: returnObj?.sso_id || globalService?.sso_id || globalService?.globalParams?.sso_id || '',
      TAX_YEAR: returnObj?.TAX_YEAR || filterParams?.tax_year || globalService?.tax_year || ''
    };
    
    // Build JSON objects exactly like AngularJS service
    const jsonObj = JSON.stringify(details || []);
    const jsonSettings = JSON.stringify(clobSettings);
    
    // 🚀 CRITICAL: Build params exactly like AngularJS service
    let params: any = _.merge({}, globalService || {}, filterParams);
    
    // Add clob_data and clob_settings
    params = _.extend({ clob_data: jsonObj }, params);
    params = _.extend({ clob_settings: jsonSettings }, params);
    
    // 🚀 CRITICAL: Add individual params at top level
    params.sso_id = clobSettings.sso_id;
    params.tax_year = clobSettings.TAX_YEAR;
    params.scenario = filterParams?.scenario || globalService?.scenario || globalService?.globalParams?.scenario || '';
    params.jcd_key = filterParams?.jcd_key || globalService?.jcd_key || globalService?.globalParams?.jcd_key || '';
    params.screen_key = filterParams?.screen_key || globalService?.screen_key || globalService?.globalParams?.screen_key || '';
    
    // 🚀 CRITICAL: Add additional required fields
    params.jcd_ta_key = filterParams?.jcd_ta_key || globalService?.jcd_ta_key || globalService?.globalParams?.jcd_ta_key || '';
    params.activity_key = filterParams?.activity_key || globalService?.activity_key || globalService?.globalParams?.activity_key || '';
    params.screen_type = filterParams?.screen_type || globalService?.screen_type || globalService?.globalParams?.screen_type || 'grid';
    params.is_locked = filterParams?.is_locked || globalService?.is_locked || globalService?.globalParams?.is_locked || 'N';
    params.issue_id = filterParams?.issue_id || globalService?.issue_id || globalService?.globalParams?.issue_id || '';
    params.issue_short_desc = filterParams?.issue_short_desc || globalService?.issue_short_desc || globalService?.globalParams?.issue_short_desc || '';
    params.issue_id_for_tx_save = filterParams?.issue_id_for_tx_save || globalService?.issue_id_for_tx_save || globalService?.globalParams?.issue_id_for_tx_save || '';
    params.scenarioCode = filterParams?.scenarioCode || filterParams?.scenario_code || globalService?.scenarioCode || globalService?.scenario_code || 'RAF';
    params.is_issue_key_enabled = filterParams?.is_issue_key_enabled || globalService?.is_issue_key_enabled || globalService?.globalParams?.is_issue_key_enabled || 'N';
    
    // Set process_name based on component
    params.process_name = "FORM1118_CONFIG_SAVE";

    // 🚀 CRITICAL: Use application/x-www-form-urlencoded (NOT json)
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      }),
      withCredentials: true
    };

    return this.http.post<any>(url, urlEncoded.toString(), httpOptions);
  }

  // 🚀 CRITICAL: Split loadJsonObject into separate methods for each action code
  // This provides better maintainability and clarity for action-code-specific parameters

  checkLockStatus(
    baseUrl: string,
    p_scenario: string,
    p_jcd_key: string,
    globalService: any,
    filterParams: any = {}
  ): Observable<any> {
    let params: any = _.merge({}, globalService || {}, filterParams);
    
    // 🚀 CRITICAL: Set action_code first
    params.action_code = 'n10cpv';
    
    // 🚀 CRITICAL: Set all required parameters with proper fallback chains (matching exact parameter list)
    params.tax_year = filterParams?.tax_year || globalService?.tax_year || globalService?.globalParams?.tax_year || '';
    params.scenario = filterParams?.scenario || globalService?.scenario || globalService?.globalParams?.scenario || '';
    params.jcd_key = filterParams?.jcd_key || globalService?.jcd_key || globalService?.globalParams?.jcd_key || '';
    params.screen_key = filterParams?.screen_key || globalService?.screen_key || globalService?.globalParams?.screen_key || '';
    params.jcd_ta_key = filterParams?.jcd_ta_key || globalService?.jcd_ta_key || globalService?.globalParams?.jcd_ta_key || '';
    params.activity_key = filterParams?.activity_key || globalService?.activity_key || globalService?.globalParams?.activity_key || '';
    params.filing_key = filterParams?.filing_key || globalService?.filing_key || globalService?.globalParams?.filing_key || '';
    params.screen_type = filterParams?.screen_type || globalService?.screen_type || globalService?.globalParams?.screen_type || 'grid';
    params.is_locked = filterParams?.is_locked || globalService?.is_locked || globalService?.globalParams?.is_locked || 'N';
    params.issue_id = filterParams?.issue_id || globalService?.issue_id || globalService?.globalParams?.issue_id || '';
    params.issue_short_desc = filterParams?.issue_short_desc || globalService?.issue_short_desc || globalService?.globalParams?.issue_short_desc || '';
    params.issue_id_for_tx_save = filterParams?.issue_id_for_tx_save || globalService?.issue_id_for_tx_save || globalService?.globalParams?.issue_id_for_tx_save || '';
    params.scenarioCode = filterParams?.scenarioCode || filterParams?.scenario_code || globalService?.scenarioCode || globalService?.scenario_code || 'RAF';
    params.is_issue_key_enabled = filterParams?.is_issue_key_enabled || globalService?.is_issue_key_enabled || globalService?.globalParams?.is_issue_key_enabled || 'N';
    params.parent_me_string = filterParams?.parent_me_string || globalService?.parent_me_string || globalService?.globalParams?.parent_me_string || '';
    
    // 🚀 CRITICAL: Set p_scenario and p_jcd_key with fallback to scenario/jcd_key
    params.p_scenario = p_scenario || filterParams?.scenario || globalService?.scenario || globalService?.globalParams?.scenario || '';
    params.p_jcd_key = p_jcd_key || filterParams?.jcd_key || globalService?.jcd_key || globalService?.globalParams?.jcd_key || '';

    return this._makeLoadRequest(baseUrl, params);
  }


  getFilingGroupInfo(
    baseUrl: string,
    globalService: any,
    filterParams: any = {}
  ): Observable<any> {
    // 🚀 CRITICAL: Build params with all required fields for action code '35gc5l'
    const params: any = {
      "action_code": "35gc5l",
      "activity_key": filterParams?.activity_key || globalService?.activity_key || '6608',
      "filing_group_key": filterParams?.filing_group_key || globalService?.filing_group_key || '1',
      "is_issue_key_enabled": filterParams?.is_issue_key_enabled || globalService?.is_issue_key_enabled || 'N',
      "is_locked": filterParams?.is_locked || globalService?.is_locked || 'N',
      "issue_id": filterParams?.issue_id || globalService?.issue_id || '',
      "issue_id_for_tx_save": filterParams?.issue_id_for_tx_save || globalService?.issue_id_for_tx_save || '',
      "issue_short_desc": filterParams?.issue_short_desc || globalService?.issue_short_desc || '',
      "jcd_key": filterParams?.jcd_key || globalService?.jcd_key || '250',
      "jcd_ta_key": filterParams?.jcd_ta_key || globalService?.jcd_ta_key || '5353',
      "scenario": filterParams?.scenario || globalService?.scenario || '',
      "scenarioCode": filterParams?.scenarioCode || filterParams?.scenario_code || globalService?.scenarioCode || globalService?.scenario_code || 'RAF',
      "screen_key": filterParams?.screen_key || globalService?.screen_key || '10771',
      "screen_type": filterParams?.screen_type || globalService?.screen_type || 'grid',
      "tax_year": filterParams?.tax_year || globalService?.tax_year || ''
    };

    return this._makeLoadRequest(baseUrl, params);
  }

  getSavedConfigData(
    baseUrl: string,
    globalService: any,
    filterParams: any = {}
  ): Observable<any> {
    let params: any = _.merge({}, globalService || {}, filterParams);
    
    params.action_code = 'hislex';
    params.tax_year = filterParams?.tax_year || globalService?.tax_year || globalService?.globalParams?.tax_year || '';
    params.scenario = filterParams?.scenario || globalService?.scenario || globalService?.globalParams?.scenario || '';
    params.jcd_key = filterParams?.jcd_key || globalService?.jcd_key || globalService?.globalParams?.jcd_key || '';
    params.screen_key = filterParams?.screen_key || globalService?.screen_key || globalService?.globalParams?.screen_key || '';
    params.jcd_ta_key = filterParams?.jcd_ta_key || globalService?.jcd_ta_key || globalService?.globalParams?.jcd_ta_key || '';
    params.activity_key = filterParams?.activity_key || globalService?.activity_key || globalService?.globalParams?.activity_key || '';
    params.filing_group_key = filterParams?.filing_group_key || globalService?.filing_group_key || globalService?.globalParams?.filing_group_key || '';
    params.screen_type = filterParams?.screen_type || globalService?.screen_type || globalService?.globalParams?.screen_type || 'grid';
    params.is_locked = filterParams?.is_locked || globalService?.is_locked || globalService?.globalParams?.is_locked || 'N';
    params.issue_id = filterParams?.issue_id || globalService?.issue_id || globalService?.globalParams?.issue_id || '';
    params.issue_short_desc = filterParams?.issue_short_desc || globalService?.issue_short_desc || globalService?.globalParams?.issue_short_desc || '';
    params.issue_id_for_tx_save = filterParams?.issue_id_for_tx_save || globalService?.issue_id_for_tx_save || globalService?.globalParams?.issue_id_for_tx_save || '';
    params.scenarioCode = filterParams?.scenarioCode || filterParams?.scenario_code || globalService?.scenarioCode || globalService?.scenario_code || 'RAF';
    params.is_issue_key_enabled = filterParams?.is_issue_key_enabled || globalService?.is_issue_key_enabled || globalService?.globalParams?.is_issue_key_enabled || 'N';

    return this._makeLoadRequest(baseUrl, params);
  }

  /**
   * Get config name information
   * Action Code: 'xxgk31'
   * Required params: Standard parameters (tax_year, scenario, jcd_key, etc.) are added by service
   */
  getConfigNameInfo(
    baseUrl: string,
    globalService: any,
    filterParams: any = {}
  ): Observable<any> {
    let params: any = _.merge({}, globalService || {}, filterParams);
    
    params.action_code = 'xxgk31';
    params.tax_year = filterParams?.tax_year || globalService?.tax_year || globalService?.globalParams?.tax_year || '';
    params.scenario = filterParams?.scenario || globalService?.scenario || globalService?.globalParams?.scenario || '';
    params.jcd_key = filterParams?.jcd_key || globalService?.jcd_key || globalService?.globalParams?.jcd_key || '';
    params.screen_key = filterParams?.screen_key || globalService?.screen_key || globalService?.globalParams?.screen_key || '';
    params.jcd_ta_key = filterParams?.jcd_ta_key || globalService?.jcd_ta_key || globalService?.globalParams?.jcd_ta_key || '';
    params.activity_key = filterParams?.activity_key || globalService?.activity_key || globalService?.globalParams?.activity_key || '';
    params.filing_group_key = filterParams?.filing_group_key || globalService?.filing_group_key || globalService?.globalParams?.filing_group_key || '';
    params.screen_type = filterParams?.screen_type || globalService?.screen_type || globalService?.globalParams?.screen_type || 'grid';
    params.is_locked = filterParams?.is_locked || globalService?.is_locked || globalService?.globalParams?.is_locked || 'N';
    params.issue_id = filterParams?.issue_id || globalService?.issue_id || globalService?.globalParams?.issue_id || '';
    params.issue_short_desc = filterParams?.issue_short_desc || globalService?.issue_short_desc || globalService?.globalParams?.issue_short_desc || '';
    params.issue_id_for_tx_save = filterParams?.issue_id_for_tx_save || globalService?.issue_id_for_tx_save || globalService?.globalParams?.issue_id_for_tx_save || '';
    params.scenarioCode = filterParams?.scenarioCode || filterParams?.scenario_code || globalService?.scenarioCode || globalService?.scenario_code || 'RAF';
    params.is_issue_key_enabled = filterParams?.is_issue_key_enabled || globalService?.is_issue_key_enabled || globalService?.globalParams?.is_issue_key_enabled || 'N';
    params.parent_me_string = filterParams?.parent_me_string || globalService?.parent_me_string || globalService?.globalParams?.parent_me_string || '';

    return this._makeLoadRequest(baseUrl, params);
  }

  /**
   * Private helper method to make the HTTP request
   * Builds URL with all parameters as query string and makes POST request
   * 🚀 CRITICAL: Includes empty strings to match AngularJS behavior
   */
  private _makeLoadRequest(baseUrl: string, params: any): Observable<any> {
    const urlParams = new URLSearchParams();
    Object.keys(params).forEach(key => {
      // 🚀 CRITICAL: Include all values including empty strings to match AngularJS URL structure
      // Empty strings are included because '' !== undefined && '' !== null
      if (params[key] !== undefined && params[key] !== null) {
        urlParams.set(key, params[key].toString());
      }
    });
    
    // Build URL with all parameters in query string: baseUrl/loadJsonObject?action_code=xxgk31&...
    const url = `${baseUrl}/loadJsonObject?${urlParams.toString()}`;

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(url, '', { headers, withCredentials: true });
  }

  /**
   * @deprecated Use specific action code methods instead (checkLockStatus, getFilingGroupInfo, getSavedConfigData, getConfigNameInfo)
   * Generic loadJsonObject method for backward compatibility
   */
  loadJsonObject(
    baseUrl: string,
    requestParams: any,
    globalService: any,
    filterParams: any = {},
    rowData: any = {}
  ): Observable<any> {
    
    // 🚀 CRITICAL: Build params exactly like AngularJS service
    let params: any = _.merge({}, globalService || {}, filterParams, requestParams);
    
    // 🚀 CRITICAL: Ensure action_code is included from requestParams
    if (requestParams?.action_code) {
      params.action_code = requestParams.action_code;
    }
    
    // 🚀 CRITICAL: Add all required parameters with proper fallback chains
    params.tax_year = filterParams?.tax_year || globalService?.tax_year || globalService?.globalParams?.tax_year || '';
    params.scenario = filterParams?.scenario || globalService?.scenario || globalService?.globalParams?.scenario || '';
    params.jcd_key = filterParams?.jcd_key || globalService?.jcd_key || globalService?.globalParams?.jcd_key || '';
    params.screen_key = filterParams?.screen_key || globalService?.screen_key || globalService?.globalParams?.screen_key || '';
    params.jcd_ta_key = filterParams?.jcd_ta_key || globalService?.jcd_ta_key || globalService?.globalParams?.jcd_ta_key || '';
    params.activity_key = filterParams?.activity_key || globalService?.activity_key || globalService?.globalParams?.activity_key || '';
    params.filing_group_key = filterParams?.filing_group_key || globalService?.filing_group_key || globalService?.globalParams?.filing_group_key || '';
    params.screen_type = filterParams?.screen_type || globalService?.screen_type || globalService?.globalParams?.screen_type || 'grid';
    params.is_locked = filterParams?.is_locked || globalService?.is_locked || globalService?.globalParams?.is_locked || 'N';
    params.issue_id = filterParams?.issue_id || globalService?.issue_id || globalService?.globalParams?.issue_id || '';
    params.issue_short_desc = filterParams?.issue_short_desc || globalService?.issue_short_desc || globalService?.globalParams?.issue_short_desc || '';
    params.issue_id_for_tx_save = filterParams?.issue_id_for_tx_save || globalService?.issue_id_for_tx_save || globalService?.globalParams?.issue_id_for_tx_save || '';
    params.scenarioCode = filterParams?.scenarioCode || filterParams?.scenario_code || globalService?.scenarioCode || globalService?.scenario_code || 'RAF';
    params.is_issue_key_enabled = filterParams?.is_issue_key_enabled || globalService?.is_issue_key_enabled || globalService?.globalParams?.is_issue_key_enabled || 'N';
    params.parent_me_string = filterParams?.parent_me_string || globalService?.parent_me_string || globalService?.globalParams?.parent_me_string || '';
    
    // 🚀 CRITICAL: For action_codes 'n10cpv' and '35gc5l', ensure p_scenario and p_jcd_key are set from requestParams or fallback to scenario/jcd_key
    if (requestParams?.p_scenario !== undefined && requestParams?.p_scenario !== null && requestParams?.p_scenario !== '') {
      params.p_scenario = requestParams.p_scenario;
    } else {
      params.p_scenario = params.scenario;
    }
    
    if (requestParams?.p_jcd_key !== undefined && requestParams?.p_jcd_key !== null && requestParams?.p_jcd_key !== '') {
      params.p_jcd_key = requestParams.p_jcd_key;
    } else {
      params.p_jcd_key = params.jcd_key;
    }
    
    return this._makeLoadRequest(baseUrl, params);
  }
}

